export function resolveOrganizationFilter(selected, organizations, loaded, admin) {
  if (!admin) return 'all';
  if (!loaded) return selected;
  return selected === 'all' || organizations.some(org => org.id === selected) ? selected : 'all';
}
